<ces-asset-breadcrumb [trail]="nav.breadcrumbTrail()" />
<div class="px-(--space-4)">
  <ces-route-title [count]="totalCampaignsCount()">
    @if (gridConfig.canManageCampaigns()) {
      <ces-menu-button-secondary icon="more_vert" [items]="nav.assetMenuItems()" />
      <ces-button [label]="'entities.campaign.messages.newButton' | transloco" icon="add" (onClick)="createNewCampaign()" />
    }
  </ces-route-title>

  @if (!loading.canShowComponents()) {
    <ces-campaign-list-skeleton />
  }

  @if (loading.canShowComponents()) {
    <div>
      <h2 class="pt-(--space-4) pb-(--space-4)">
        {{ 'entities.campaign.sections.open' | transloco }}
        @if (testMode.testMode()) {
          <span class="text-sm text-(color:--text-secondary)">({{ openCampaigns().length }})</span>
        }
      </h2>
      @if (openCampaignsWithMenuItems().length > 0 && canViewCampaigns()) {
        <ces-card-carousel [value]="openCampaignsWithMenuItems()">
          <ng-template let-campaign #item>
            <ces-card
              [title]="campaignTitle(campaign)"
              [bodyDescription]="campaign.comment || ('entities.campaign.messages.noComment' | transloco)"
              [items]="campaign.menuItems"
              [hasPermission]="{ method: 'putCampaignDetailResource', assetId: currentAssetId() ?? undefined }"
              [href]="campaignHref(campaign)"
              (cardClick)="navigateToCampaign(campaign.id)"
              [clickable]="true">
              <ng-template #footer>
                <div class="flex flex-col gap-1.5 min-w-0">
                  <span class="text-xs text-(color:--text-secondary) truncate">{{ campaign.operator }}</span>
                  <div class="flex items-center gap-1.5 flex-nowrap">
                    <p-tag
                      rounded="true"
                      [severity]="getTagSeverity(campaign.status)"
                      [value]="getStatusKey(campaign.status) | transloco"
                      styleClass="whitespace-nowrap text-xs" />
                    <ces-campaign-tags
                      [hasPendingConflicts]="campaign.hasPendingConflicts"
                      [hasImportedData]="campaign.hasImportedData"
                      (resolveConflicts)="onResolveConflicts(campaign)" />
                  </div>
                </div>
              </ng-template>
            </ces-card>
          </ng-template>
        </ces-card-carousel>
      }
      @if (!openCampaigns().length) {
        <div class="text-(color:--text-secondary) italic py-(--space-8)">
          {{ 'entities.campaign.messages.noOpenCampaigns' | transloco }}
        </div>
      }
    </div>
    <div>
      <h2 class="pt-(--space-8) pb-(--space-4)">
        {{ 'entities.campaign.sections.closed' | transloco }}
        @if (testMode.testMode()) {
          <span class="text-sm text-(color:--text-secondary)"> ({{ totalRecords() }}) </span>
        }
      </h2>
      @if (loading.campaignDataLoading()) {
        <ces-grid-skeleton [lines]="rows()" />
      } @else {
        <div class="flex flex-col gap-(--gap-relaxed)">
          @if (totalRecords() > 0 || hasActiveFilters()) {
            <div class="relative">
              <ces-button-secondary
                [icon]="gridConfig.isFiltering() ? 'filter_alt_off' : 'filter_alt'"
                [label]="'common.labels.columns' | transloco"
                #columnButton
                (onClick)="toggleColumnSelector($event)" />
              <ces-checkable-menu
                #columnMenu
                [popup]="true"
                [model]="gridConfig.combinedColumnMenuItems()"
                appendTo="body"
                [baseZIndex]="1000">
                <ng-template #end>
                  <div class="flex flex-row justify-between gap-(--gap-normal) px-(--space-2) pb-(--space-2)">
                    <ces-button-tertiary [label]="'common.labels.none' | transloco" (onClick)="uncheckAllColumns()" size="small" />
                    <ces-button-tertiary [label]="'common.labels.all' | transloco" (onClick)="checkAllColumns()" size="small" />
                  </div>
                </ng-template>
              </ces-checkable-menu>
            </div>
          }
          @if (testMode.testMode()) {
            <pre class="h-60 overflow-y-scroll">{{ campaignsWithPuces() | json }}</pre>
          }
          @if (totalRecords() > 0 || hasActiveFilters()) {
            <div>
              <ces-generic-parent-grid
                [entityDefinition]="tableDefinitionWithSort()"
                [entities]="campaignsWithPuces()"
                [dataLoadingCompleted]="true"
                [paginator]="true"
                [totalRecords]="totalRecords()"
                [first]="first()"
                [rows]="rows()"
                [initialFilters]="urlFilters()"
                (lazyLoad)="onLazyLoad($event)"
                (customAction)="onCustomCampaignAction($event.action, $event.entity)"
                (puceRecalculate)="handlePuceRecalculation($event)"
                [selectionMode]="false" />
            </div>
          }
          @if (totalRecords() === 0 && !hasActiveFilters()) {
            <div class="text-(color:--text-secondary) italic py-(--space-8) text-center">
              {{ 'entities.campaign.messages.noClosedCampaigns' | transloco }}
            </div>
          }
        </div>
      }
    </div>
  }
</div>
